import { render, staticRenderFns } from "./HiddenWidgets.vue?vue&type=template&id=b341693a"
import script from "./HiddenWidgets.vue?vue&type=script&lang=js"
export * from "./HiddenWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports